function loadMoreProducts(_url) {
    function getQueryParam(param) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    const delkaod = getQueryParam('delkaod') || 0;
    const delkado = getQueryParam('delkado') || 0;
    const sirkaod = getQueryParam('sirkaod') || 0;
    const sirkado = getQueryParam('sirkado') || 0;
    const skladem = getQueryParam('skladem') || 0;


    const url = `/?ajax=loadmoreproducts`,
        additionalParams = `&delkaod=${delkaod}&delkado=${delkado}&sirkaod=${sirkaod}&sirkado=${sirkado}&skladem=${skladem}`,
        body = `&url=${encodeURIComponent(_url)}&page=${window.afterPage}&preloaded=${window.preloaded}${additionalParams}`,
        querySelector = '.products',
        position = 'beforeend',
        fnAfter = 'loadMoreProductsAfter',
        method = 'POST',
        responseType = 'json',
        dataProperty = 'content',
        dataProperty2 = 'hidebutton',
        runScripts = 1;
    // console.log("body: " + body);
    window.preloaded = 0;
    loadData(url, body, querySelector, position, fnAfter, method, responseType, dataProperty, dataProperty2, runScripts);
}

function loadMoreProductsAfter(isHidebutton) {
    const countProductItems = () => {
        const productItems = document.querySelectorAll('.product-item');
        return productItems.length;
    };
    const productItems = countProductItems();
    if (productItems > 0) {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('loaded', productItems);
        const newURL = `${window.location.pathname}?${urlParams.toString()}`;
        history.pushState({}, '', newURL);
    }
    setRobots('noindex,follow');
    removeLinkTags();
    window.afterPage++;
    tooltipControl();
    setCounter();
    checkPcsLengthOnPage();
    const loadMoreButton = document.getElementById('loadmore');
    if (loadMoreButton) {
        loadMoreButton.setAttribute('aria-expanded', 'true');
    }
    const loadMoreMessage = document.getElementById('loadmore-success-message');
    if (loadMoreMessage) {
        const text = loadMoreMessage.getAttribute('data-text');
        loadMoreMessage.textContent = '';
        setTimeout(() => {
            loadMoreMessage.textContent = text;
        }, 10);
        // console.info(text);
    }

    if (isHidebutton) {
        loadMoreButton.style.display = "none";
    }
    setTimeout(() => {
        loadMoreButton.href = `#after-page-${window.afterPage}`;
        const targetElement = document.getElementById(`after-page-${window.afterPage - 1}`);
        if (targetElement) {
            scrollToTarget(targetElement);
        }
    }, 500);

}

function handleFetchUrl() {
    if (!isNaN(window.loaded) && window.loaded > 0) {
        const quotient = Math.floor(window.loaded / 20);
        const residue = window.loaded % 20;
        const morePagesLoaded = quotient - 1;

        if (window.afterPage === 0 && window.loaded < 20) {
            window.preloaded = residue;
        } else {
            window.afterPage = window.afterPage + morePagesLoaded;
            window.preloaded = residue;
        }

        window.loaded = 0;
    }
}

function appendToURL(suffix) {
    var currentURL = window.location.href;
    var newURL = currentURL + suffix;
    history.pushState({}, '', newURL);
}

function setRobots(content) {
    const robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) {
        robotsTag.setAttribute('content', content);
    }
}

function removeLinkTags() {
    const linkTags = document.querySelectorAll('link[rel="canonical"], link[rel="alternate"]');
    if (linkTags.length > 0) {
        linkTags.forEach(link => {
            link.parentNode.removeChild(link);
        });
    }
};

handleFetchUrl();

const loadMoreButton = document.getElementById('loadmore');
if (loadMoreButton) {
    if (window.category_url !== undefined && window.afterPage !== undefined) {
        loadMoreButton.href = `#after-page-${window.afterPage}`;
        loadMoreButton.addEventListener('click', () => loadMoreProducts(window.category_url));
    } else {
        loadMoreButton.style.display = "none";
    }
}